import {StandingOrder} from 'app/blocks/model/standing-order.model';
import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Resource} from 'app/constants/resource';
import {IStandingOrder} from 'app/blocks/model/standing-order.model';
import EntityCrudService from 'app/blocks/service/api/entity-service';
import {SERVER_API_URL} from 'app/app.constants';
import {createRequestOption} from 'app/blocks/util/request-util';
import {Observable} from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class StandingLoadOrderService extends EntityCrudService<IStandingOrder> {
    constructor(http: HttpClient) {
        super(http, Resource.STANDING_ORDERS, (obj?) => new StandingOrder(obj));
    }

    generateLoadOrderForNextSchedule(selectedStandingOrderIds: number[]): Promise<any> {
        const REQUEST_URI = `${SERVER_API_URL}api/standing-orders/generate-orders-for-next-schedule`;
        const requestBody = createRequestOption({
            ids: selectedStandingOrderIds
        });
        return this.http
            .post<any>(REQUEST_URI, requestBody, {
                observe: 'response'
            })
            .toPromise();
    }

    public downloadMergedStandingOrders = (standingOrderIds: number[]): Observable<ArrayBuffer> => {
        const requestParams = new HttpParams().set('ids', standingOrderIds.toString());
        const REQUEST_URI = `${SERVER_API_URL}api/standing-orders/download`;
        return this.http.get(REQUEST_URI, {
            responseType: 'arraybuffer',
            params: requestParams
        });
    };
}
